import { GiReceiveMoney } from "react-icons/gi";
import { MdOutlineAutoGraph, MdAppShortcut } from "react-icons/md";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import Reveal from "./Reveal";

const steps = [
  {
    header: "Setup",
    text: "Easily onboard with AYOZAT and integrate PPV into your stream on ayozat.com.",
    icon: GiReceiveMoney,
  },
  {
    header: "Ticket Sales",
    text: "Market your event across AYOZAT, your platforms, and your brand's audience to maximize ticket sales.",
    icon: MdAppShortcut,
  },
  {
    header: "Go Live",
    text: "Your event streams live to ticket holders, providing a new distribution point and an exclusive experience from the comfort of home.",
    icon: AiOutlineUsergroupAdd,
  },
  {
    header: "Reap the Rewards",
    text: "After your PPV event ends, you'll get paid, your fan base will grow, and you can focus on planning your next event.",
    icon: MdOutlineAutoGraph,
  },
];

const ProcessSteps = () => {
  return (
    <div className="mx-auto mb-24 grid w-full max-w-5xl grid-cols-2 gap-5 max-sm:grid-cols-1">
      {steps.map((step, i) => {
        const Icon = step.icon;
        return (
          <Reveal key={step.header} delay={i * 90} className="h-full">
            <div className="flex h-full items-start gap-5 rounded-2xl border border-white/10 bg-white/[0.03] p-7 backdrop-blur-sm transition-all duration-300 hover:border-[var(--red)]/40 hover:bg-white/[0.05]">
              <div className="flex shrink-0 flex-col items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-[15px] font-bold text-white">
                  {i + 1}
                </div>
                <Icon size={20} className="text-[var(--red)]" />
              </div>
              <div>
                <h3 className="mb-2 text-[18px] font-bold text-white">
                  {step.header}
                </h3>
                <p className="text-[14px] leading-relaxed text-white/55">
                  {step.text}
                </p>
              </div>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
};

export default ProcessSteps;
